import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from '@event-images/translations';
import React from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {
  AppInsightsErrorBoundary,
  ReactPlugin
} from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { Api, apiInstance } from '@backend/api';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
// *** Add the Click Analytics plug-in. ***
/* var clickPluginInstance = new ClickAnalyticsPlugin();
   var clickPluginConfig = {
     autoCapture: true
}; */


const appInsights = new ApplicationInsights({
  config: {
    connectionString:
      'InstrumentationKey=972c5039-782b-4025-a99c-5d37640b8b34;IngestionEndpoint=https://italynorth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://italynorth.livediagnostics.monitor.azure.com/;ApplicationId=21c6094f-1e7e-45bb-a7b4-9088f653dc00',
    // *** If you're adding the Click Analytics plug-in, delete the next line. ***
    extensions: [reactPlugin],
    // *** Add the Click Analytics plug-in. ***
    // extensions: [reactPlugin, clickPluginInstance],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
      // *** Add the Click Analytics plug-in. ***
      // [clickPluginInstance.identifier]: clickPluginConfig
    }
  }
});
appInsights.loadAppInsights();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const api = apiInstance;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'de', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
/*
root.render(
  // can cause unexplainable double rendering
  <StrictMode>
    <App />
  </StrictMode>
);

*/
root.render(
  // can cause unexplainable double rendering
  <StrictMode>
    <AppInsightsErrorBoundary
      onError={() => <h1>I believe something went wrong</h1>}
      appInsights={reactPlugin}
    >
      <App />
    </AppInsightsErrorBoundary>
  </StrictMode>
);

